/**
 * @Author: Zero
 * @Date: 2023-03-10 14:15:56
 * @Explain: API key 接口
 */

import type { HttpResponse } from '../data.d';
import http from '../http';

const MODEL = '/openApi';
const MODEL_ONE = '/open_api';

export default {
  // 获取 业务是否授权 及 导入进度
  getGameAuth(): Promise<HttpResponse> {
    return http.post(`${MODEL}/game-auth`);
  },
  // 列表
  getList(data: Record<any, any>): Promise<HttpResponse> {
    return http.post(`${MODEL}/list`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 生成密钥
  onSecret(data: Record<any, any>): Promise<HttpResponse> {
    return http.post(`${MODEL}/create-key`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 检查名称
  checkName(data: Record<any, any>): Promise<HttpResponse> {
    return http.post(`${MODEL}/check-name`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 创建
  onCreate(data: Record<any, any>): Promise<HttpResponse> {
    return http.post(`${MODEL_ONE}/create`, data, {
      params: {
        switchReqToUnderline: true,
        ignoreConvertedKey: JSON.stringify([
          'attributes_default_value',
          'attributesDefaultValue',
          // 'isAttributesDefaultValue',
        ]),
        // 忽略 rep attributes_default_value 对象 大小写转化
        ignoreConvertedValueKey: JSON.stringify([
          'attributes_default_value',
          'attributesDefaultValue',
        ]),
      },
    });
  },
  // 编辑
  onEdit(data: Record<any, any>): Promise<HttpResponse> {
    return http.post(`${MODEL_ONE}/edit`, data, {
      params: {
        switchReqToUnderline: true,
        ignoreConvertedKey: JSON.stringify([
          'attributes_default_value',
          'attributesDefaultValue',
          // 'isAttributesDefaultValue',
        ]),
        // 忽略 rep attributes_default_value 对象 大小写转化
        ignoreConvertedValueKey: JSON.stringify([
          'attributes_default_value',
          'attributesDefaultValue',
        ]),
      },
    });
  },
  // 编辑 - 二次确认邮件设置
  onEditOptIn(data: Record<any, any>): Promise<HttpResponse> {
    return http.post(`${MODEL_ONE}/edit_optin`, data, {
      params: {
        switchReqToUnderline: true,
        ignoreConvertedKey: JSON.stringify([
          'attributes_default_value',
          'attributesDefaultValue',
          // 'isAttributesDefaultValue',
        ]),
        // 忽略 rep attributes_default_value 对象 大小写转化
        ignoreConvertedValueKey: JSON.stringify([
          'attributes_default_value',
          'attributesDefaultValue',
        ]),
      },
    });
  },
  // 撤销
  onRevoke(data: Record<any, any>): Promise<HttpResponse> {
    return http.post(`${MODEL}/revoke`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 获取详情
  getDetails(data: Record<any, any>): Promise<HttpResponse> {
    return http.post(`${MODEL_ONE}/detail`, data, {
      params: {
        switchReqToUnderline: true,
        ignoreConvertedValueKey: JSON.stringify(['attributes_default_value']),
      },
    });
  },
  // 获取上次配置
  getLastOptInConfig(data: Record<any, any>) {
    return http.post(`${MODEL_ONE}/get_optin_last_config`, data, {
      params: { switchReqToUnderline: true },
    });
  },
};
